// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__vJPD8"};